import React from 'react';
import PropTypes from 'prop-types';
import { formatReviewSku } from '@rsc/utils';

function QandA({ sku }) {
  return (
    <div data-bv-show="questions" data-bv-product-id={formatReviewSku(sku)} />
  );
}

QandA.propTypes = {
  sku: PropTypes.string,
};

QandA.defaultProps = {
  sku: '',
};

export default QandA;
